import { QuestionBase } from './question-base';

export class NumerictextboxQuestion extends QuestionBase<any> {
  controlType = 'numerictextbox';
}